import React from "react";
import { Link } from "react-router-dom";
import {
  FaExclamationTriangle,
  FaHome,
  FaWhatsapp,
  FaEnvelope,
} from "react-icons/fa";
import "./PageNotFound.css";

const PageNotFound = () => {
  return (
    <div className="nf-wrapper">
      <div className="nf-card">
        {/* ICON */}
        <div className="nf-icon">
          <FaExclamationTriangle />
        </div>

        <h1 className="nf-code">404</h1>
        <h2 className="nf-title">This Page Doesn’t Exist</h2>

        <p className="nf-message">
          The page you’re looking for may have been removed, renamed, or is
          temporarily unavailable. Let’s help you continue smoothly.
        </p>

        {/* ACTIONS */}
        <div className="nf-actions">
          <Link to="/" className="nf-btn ghost">
            <FaHome />
            Home
          </Link>

          <Link to="/contact" className="nf-btn primary">
            <FaEnvelope />
            Contact Us
          </Link>
        </div>

        {/* SUPPORT */}
        <div className="nf-support">
          <span>Need instant help?</span>
          <a
            href="https://wa.me/919999999999?text=Hi%20Oglitz%2C%20I%20hit%20a%20404%20page%20on%20your%20website."
            target="_blank"
            rel="noopener noreferrer"
            className="nf-whatsapp"
          >
            <FaWhatsapp />
            WhatsApp Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
